var resizeTimer;jQuery(document).ready((function(){jQuery("div.category-toggle").click((function(){var t=jQuery(this),e=jQuery(this).next("ul.subcat-list");t.toggleClass("active"),e.toggleClass("active");var i=t.hasClass("active");t.attr("aria-expanded",i),jQuery("ul.subcat-list").not(e).removeClass("active"),jQuery("div.category-toggle").not(t).removeClass("active").attr("aria-expanded",!1)}));var t=window.location.pathname;0==t.indexOf("/collections/")&&-1==t.indexOf("/products/")&&jQuery((function(){$.scrollUp({scrollText:""})}))})),window._minimizeContent=function(){function _minAppend(el,html){var t=el.lastElementChild,host=t&&/^(P|DIV|LI|UL|OL|H[1-6])$/.test(t.tagName)?t:el;if("UL"===host.tagName||"OL"===host.tagName)host=host.lastElementChild||el;var s=document.createElement("span");s.innerHTML=html,host.appendChild(s)}function _minCut(el,n,suffix){el.innerHTML=el._minFull;var nd,w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT),c=0,cutN=null,off=0;for(;nd=w.nextNode();){if(c+nd.data.length>=n){cutN=nd,off=n-c;break}c+=nd.data.length}if(!cutN)return!1;var r=document.createRange();r.setStart(cutN,off),r.setEndAfter(el.lastChild),r.deleteContents();for(var host=cutN.parentNode;host!==el&&!/^(P|DIV|LI|H[1-6])$/.test(host.tagName);)host=host.parentNode;var s=document.createElement("span");return s.innerHTML=suffix,host.appendChild(s),!0}function _minCollapse(el){el.innerHTML=el._minFull,el.classList.add("is-collapsed");var target=el.clientHeight;if(!(el.scrollHeight>target+2))return;var nd,total=0,w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);for(;nd=w.nextNode();)total+=nd.data.length;for(var suffix='<span class="minimize-ellipsis">... </span><a href="#" class="minimize-more" role="button"><strong>more</strong></a>',lo=0,hi=total,best=0;lo<=hi;){var mid=lo+hi>>1;_minCut(el,mid,suffix),el.scrollHeight<=target+2?(best=mid,lo=mid+1):hi=mid-1}_minCut(el,best,suffix)}document.querySelectorAll(".minimize-rich").forEach((function(el){void 0===el._minFull&&(el._minFull=el.innerHTML),el._minBound||(el.addEventListener("click",(function(ev){var a=ev.target.closest("a.minimize-more,a.minimize-less");a&&el.contains(a)&&(ev.preventDefault(),a.classList.contains("minimize-more")?(el._minExpanded=!0,el.classList.remove("is-collapsed"),el.innerHTML=el._minFull,_minAppend(el,' <a href="#" class="minimize-less" role="button"><strong>less</strong></a>')):(el._minExpanded=!1,_minCollapse(el)))})),el._minBound=!0),el._minExpanded||_minCollapse(el)}))},jQuery(document).ready(window._minimizeContent),window.addEventListener("resize",(function(t){clearTimeout(resizeTimer),resizeTimer=setTimeout((function(){window._minimizeContent()}),250)}),!0),jQuery(document).ready((function(){if(window.location.href.indexOf("glossary")>-1&&$(".alpha-filter").length){var t=["a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"],e=!1;t.forEach((function(t){$(`.definition-${t}`).length||($(`#alpha-filter-${t}`).hide(),e=!0)})),e&&$("#glossary-filter-wrapper").show(),$(".alpha-filter").click((function(){var e=$(this).attr("id").split("alpha-filter-")[1];e&&($(".alpha-filter").removeClass("alpha-selected"),$(`#alpha-filter-${e}`).addClass("alpha-selected"),t.forEach((function(t){"all"==e||e==t?$(`.definition-${t}`).show():$(`.definition-${t}`).hide()})))}))}})),jQuery(document).ready((function(){$(".product-quantity-input-minus").on("click",(function(t){t.preventDefault();var e=$(".product-quantity-input").val();e||($(".product-quantity-input").val(1),e=1);var i=parseInt(e)-1;i>0&&$(".product-quantity-input").val(i)})),$(".product-quantity-input-plus").on("click",(function(t){t.preventDefault();var e=$(".product-quantity-input").val();e||($(".product-quantity-input").val(1),e=0);var i=parseInt(e)+1;$(".product-quantity-input").val(i)}))})),jQuery(document).ready((function(){$(".cart-item-quantity-minus").on("click",(function(t){t.preventDefault();var e=$(this).attr("data-variant-id"),i=$(`#cart-item-quantity-variant-id-${e}`).val(),a=parseInt(i)-1;a>0&&($(`#cart-item-quantity-variant-id-${e}`).val(a),document.querySelector(`#cart-item-quantity-variant-id-${e}`).dispatchEvent(new Event("change",{bubbles:!0})))})),$(".cart-item-quantity-plus").on("click",(function(t){t.preventDefault();var e=$(this).attr("data-variant-id"),i=$(`#cart-item-quantity-variant-id-${e}`).val(),a=parseInt(i)+1;$(`#cart-item-quantity-variant-id-${e}`).val(a),document.querySelector(`#cart-item-quantity-variant-id-${e}`).dispatchEvent(new Event("change",{bubbles:!0}))}))})),window.location.pathname.includes("/products/")&&document.addEventListener("DOMContentLoaded",(function(){var t=document.querySelectorAll(".product-tabs__label");t.forEach((function(e){e.addEventListener("click",(function(){var e=document.querySelector(".product-tabs__label.active-tab");e!==this&&(e&&(e.classList.remove("active-tab"),e.nextElementSibling.style.display="none"),this.classList.add("active-tab"),this.nextElementSibling.style.display="block");window.innerWidth<=719&&scrollToDescriptionOnTabClick&&t[0].scrollIntoView({behavior:"smooth",block:"start"})}))}))}));

/* Checkout buttons: navigate to regular checkout (skip Shop Pay auto-redirect).
   On the cart page, sync quantities + note to the cart first so last-second
   edits are never lost, then navigate. Delegated so it also works inside the
   dynamically rendered mini cart. */
document.addEventListener("click", function (event) {
  var button = event.target.closest("[data-cart-checkout-button]");
  if (!button || button.classList.contains("disabled")) return;
  event.preventDefault();
  var checkoutUrl = "/checkout?skip_shop_pay=true";
  var form = button.closest("form[data-cart-form]");
  if (!form || !window.fetch) {
    window.location.href = checkoutUrl;
    return;
  }
  button.classList.add("disabled");
  fetch("/cart/update.js", { method: "POST", body: new FormData(form) })
    .catch(function () {})
    .then(function () {
      window.location.href = checkoutUrl;
    });
});

/* Order minimum note: hide once the cart total reaches the configured
   minimum. The mini cart re-renders through Liquid on every refresh so it
   handles itself; this covers AJAX quantity changes on the cart page by
   watching the total and re-checking against /cart.js. */
(function () {
  function updateOrderMinimumNotes() {
    var notes = document.querySelectorAll("[data-order-minimum-note]");
    if (!notes.length || !window.fetch) return;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-order-minimum-note]").forEach(function (note) {
          var minimum = parseInt(note.getAttribute("data-order-minimum-cents"), 10) || 0;
          note.hidden = cart.total_price >= minimum;
        });
      })
      .catch(function () {});
  }
  document.addEventListener("DOMContentLoaded", function () {
    var cartTotal = document.querySelector("[data-cart-total]");
    if (cartTotal && window.MutationObserver) {
      new MutationObserver(updateOrderMinimumNotes).observe(cartTotal, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  });
})();

/* Save for later: adds a "Save for later" link to cart rows and a saved
   items section below the cart. Saved lines are added to the customer's
   Swish wishlist (window.WishlistKing API) so they sync across devices,
   and tracked in localStorage so only items saved FROM THE CART appear
   in the section (not the whole wishlist). If the Swish script hasn't
   loaded or errors, saving still works locally and re-syncs on the next
   cart visit. Removal from the cart reuses the theme's own remove link
   so atlantic.js handles the AJAX update and re-render. */
(function () {
  var STORAGE_KEY = "tejas_saved_for_later";
  var container = null;
  var itemsEl = null;
  var wishlistItemIds = {}; /* variantId -> Swish wishlist item id */
  var productCache = {};

  function loadMarkers() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function saveMarkers(markers) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(markers));
    } catch (e) {}
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error("timeout")); }, ms);
      promise.then(
        function (value) { clearTimeout(timer); resolve(value); },
        function (error) { clearTimeout(timer); reject(error); }
      );
    });
  }

  /* The Swish script loads async via jsdelivr; poll briefly for its API. */
  function getCreds(maxWaitMs) {
    return new Promise(function (resolve, reject) {
      var waited = 0;
      (function poll() {
        var creds = window.WishlistKing && window.WishlistKing.apis && window.WishlistKing.apis.wishlist;
        if (creds) return resolve(creds);
        if (waited >= maxWaitMs) return reject(new Error("wishlist api unavailable"));
        waited += 250;
        setTimeout(poll, 250);
      })();
    });
  }

  function wkRequest(creds, endpoint, method, payload) {
    var headers = {};
    for (var key in creds.headers) headers[key] = creds.headers[key];
    headers["x-appmate-sid"] = localStorage.getItem("wk_session_id") || "";
    var options = { method: method || "GET", headers: headers, keepalive: true };
    if (payload && (options.method === "POST" || options.method === "DELETE")) {
      options.body = JSON.stringify(payload);
    }
    return fetch(creds.host + endpoint, options)
      .then(function (response) {
        if (!response.ok) throw new Error("wishlist http " + response.status);
        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json();
        }
        return null;
      })
      .then(function (data) {
        if (data && data.sessionId) {
          try { localStorage.setItem("wk_session_id", data.sessionId); } catch (e) {}
        }
        return data;
      });
  }

  function fetchWishlistItems(creds) {
    return wkRequest(creds, "/wishlists/mine").then(function (result) {
      return (result && result.wishlist && result.wishlist.items) || [];
    });
  }

  function addToWishlist(creds, marker) {
    return wkRequest(creds, "/wishlists/mine/items", "POST", {
      variantId: marker.variantId,
      productId: marker.productId
    });
  }

  function markSynced(variantId) {
    var markers = loadMarkers();
    markers.forEach(function (marker) {
      if (marker.variantId === variantId) marker.synced = true;
    });
    saveMarkers(markers);
  }

  function removeMarker(variantId) {
    var markers = loadMarkers().filter(function (marker) {
      return marker.variantId !== variantId;
    });
    saveMarkers(markers);
    return markers;
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch("/products/" + handle + ".js", {
        headers: { Accept: "application/json" }
      }).then(function (response) {
        return response.ok ? response.json() : null;
      }).catch(function () {
        return null;
      });
    }
    return productCache[handle];
  }

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function sizedImage(url, width) {
    if (!url) return null;
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
  }

  function buildCard(marker, product) {
    if (!product || !product.variants || !product.variants.length) return null;
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === marker.variantId) {
        variant = product.variants[i];
        break;
      }
    }
    if (!variant) return null;

    var url = "/products/" + product.handle + "?variant=" + variant.id;
    var imageUrl =
      (variant.featured_image && variant.featured_image.src) ||
      (product.images && product.images[0]) ||
      product.featured_image;

    var item = document.createElement("div");
    item.className = "sfl-item";
    item.setAttribute("data-sfl-item", marker.variantId);

    var imageLink = document.createElement("a");
    imageLink.className = "sfl-image";
    imageLink.href = url;
    if (imageUrl) {
      var img = document.createElement("img");
      img.src = sizedImage(imageUrl, 180);
      img.alt = product.title;
      img.loading = "lazy";
      img.width = 90;
      img.height = 90;
      imageLink.appendChild(img);
    }
    item.appendChild(imageLink);

    var details = document.createElement("div");
    details.className = "sfl-details";

    var titleLink = document.createElement("a");
    titleLink.className = "sfl-title";
    titleLink.href = url;
    titleLink.textContent = product.title;
    details.appendChild(titleLink);

    if (variant.title && variant.title !== "Default Title") {
      var variantEl = document.createElement("span");
      variantEl.className = "sfl-variant";
      variantEl.textContent = variant.title;
      details.appendChild(variantEl);
    }

    if (marker.quantity > 1) {
      var qtyEl = document.createElement("span");
      qtyEl.className = "sfl-qty";
      qtyEl.textContent = "Qty: " + marker.quantity;
      details.appendChild(qtyEl);
    }

    var priceEl = document.createElement("span");
    priceEl.className = "sfl-price";
    var money = document.createElement("span");
    money.className = "money";
    money.textContent = formatMoney(variant.price);
    priceEl.appendChild(money);
    details.appendChild(priceEl);

    var actions = document.createElement("div");
    actions.className = "sfl-actions";

    var moveButton = document.createElement("button");
    moveButton.type = "button";
    moveButton.className = "action-button sfl-move";
    moveButton.setAttribute("data-sfl-move", marker.variantId);
    moveButton.textContent = variant.available === false ? "Sold out" : "Move to cart";
    if (variant.available === false) moveButton.disabled = true;
    actions.appendChild(moveButton);

    var removeLink = document.createElement("a");
    removeLink.className = "sfl-remove";
    removeLink.href = "#";
    removeLink.setAttribute("role", "button");
    removeLink.setAttribute("data-sfl-remove", marker.variantId);
    removeLink.textContent = "Remove";
    actions.appendChild(removeLink);

    details.appendChild(actions);
    item.appendChild(details);
    return item;
  }

  function render(markers) {
    if (!container) return;
    if (!markers.length) {
      container.hidden = true;
      itemsEl.innerHTML = "";
      return;
    }
    var jobs = markers.map(function (marker) {
      return getProduct(marker.handle).then(function (product) {
        return { marker: marker, product: product };
      });
    });
    Promise.all(jobs).then(function (results) {
      var dropped = false;
      itemsEl.innerHTML = "";
      results.forEach(function (result) {
        var card = result.product && buildCard(result.marker, result.product);
        if (card) {
          itemsEl.appendChild(card);
        } else {
          /* Product or variant no longer exists; clean up quietly. */
          removeMarker(result.marker.variantId);
          dropped = true;
        }
      });
      var remaining = dropped ? loadMarkers() : markers;
      container.hidden = remaining.length === 0 || itemsEl.children.length === 0;
    });
  }

  /* Reconcile local markers with the Swish wishlist: drop markers whose
     items were removed from the wishlist elsewhere, retry adds that
     failed at save time, and learn wishlist item ids for later removal. */
  function verify() {
    withTimeout(getCreds(6000), 7000)
      .then(function (creds) {
        return fetchWishlistItems(creds).then(function (items) {
          var byVariant = {};
          items.forEach(function (item) {
            if (item.variantId) byVariant[Number(item.variantId)] = item;
          });
          var changed = false;
          var markers = loadMarkers().filter(function (marker) {
            var wishlistItem = byVariant[marker.variantId];
            if (wishlistItem) {
              wishlistItemIds[marker.variantId] = wishlistItem.id;
              if (!marker.synced) { marker.synced = true; changed = true; }
              return true;
            }
            if (marker.synced) {
              /* Saved moments ago? The app's backend may not reflect the
                 add yet; don't trust its absence until things settle. */
              if (Date.now() - (marker.savedAt || 0) < 5 * 60 * 1000) return true;
              /* Was on the wishlist, removed elsewhere: respect that. */
              changed = true;
              return false;
            }
            /* Never made it to the wishlist; retry in the background. */
            addToWishlist(creds, marker).then(function () {
              markSynced(marker.variantId);
            }).catch(function () {});
            return true;
          });
          if (changed) {
            saveMarkers(markers);
            render(markers);
          }
        });
      })
      .catch(function () { /* Swish unavailable; local view stands. */ });
  }

  function addToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error("add failed");
      return response.json();
    });
  }

  function showError(itemEl, message) {
    if (!itemEl) return;
    var existing = itemEl.querySelector(".sfl-error");
    if (existing) existing.remove();
    var error = document.createElement("span");
    error.className = "sfl-error";
    error.textContent = message;
    itemEl.querySelector(".sfl-details").appendChild(error);
  }

  /* Save for later click (cart rows). */
  document.addEventListener("click", function (event) {
    var link = event.target.closest("[data-save-for-later]");
    if (!link) return;
    event.preventDefault();
    if (link.classList.contains("is-saving")) return;
    link.classList.add("is-saving");
    link.textContent = "Saving...";

    var row = link.closest("[data-cart-item]");
    var qtyInput = row && row.querySelector("[data-cart-item-quantity]");
    var marker = {
      productId: Number(link.getAttribute("data-product-id")),
      variantId: Number(link.getAttribute("data-variant-id")),
      handle: link.getAttribute("data-product-handle"),
      quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1,
      savedAt: Date.now(),
      synced: false
    };

    var markers = loadMarkers().filter(function (existing) {
      return existing.variantId !== marker.variantId;
    });
    markers.unshift(marker);
    saveMarkers(markers);

    var finish = function () {
      var removeLink = row && row.querySelector('[data-cart-action="remove"]');
      if (removeLink) removeLink.click();
      render(loadMarkers());
    };

    /* Try to sync to the wishlist first (bounded wait) so it survives the
       page reload the theme performs when the cart empties. keepalive on
       the request covers the navigation case too. */
    withTimeout(
      getCreds(2500).then(function (creds) {
        return addToWishlist(creds, marker);
      }),
      3500
    )
      .then(function () { markSynced(marker.variantId); })
      .catch(function () { /* verify() retries on next cart visit */ })
      .then(finish, finish);
  });

  /* Move to cart / remove clicks (saved section). */
  document.addEventListener("click", function (event) {
    var moveButton = event.target.closest("[data-sfl-move]");
    var removeLink = event.target.closest("[data-sfl-remove]");
    if (!moveButton && !removeLink) return;
    event.preventDefault();

    var variantId = Number(
      (moveButton || removeLink).getAttribute(moveButton ? "data-sfl-move" : "data-sfl-remove")
    );
    var itemEl = (moveButton || removeLink).closest("[data-sfl-item]");

    var deleteFromWishlist = function () {
      var wishlistItemId = wishlistItemIds[variantId];
      if (!wishlistItemId) return Promise.resolve();
      return withTimeout(
        getCreds(1500).then(function (creds) {
          return wkRequest(creds, "/wishlists/mine/items", "DELETE", {
            wishlistItemId: wishlistItemId
          });
        }),
        2500
      ).catch(function () {});
    };

    if (removeLink) {
      var remaining = removeMarker(variantId);
      deleteFromWishlist();
      if (itemEl) itemEl.remove();
      if (container) container.hidden = remaining.length === 0 || itemsEl.children.length === 0;
      return;
    }

    if (moveButton.disabled) return;
    var markers = loadMarkers();
    var marker = null;
    markers.forEach(function (candidate) {
      if (candidate.variantId === variantId) marker = candidate;
    });
    var quantity = (marker && marker.quantity) || 1;

    moveButton.disabled = true;
    moveButton.textContent = "Moving...";

    addToCart(variantId, quantity)
      .catch(function (error) {
        /* Saved quantity may exceed current stock; retry with one. */
        if (quantity > 1) return addToCart(variantId, 1);
        throw error;
      })
      .then(function () {
        removeMarker(variantId);
        return deleteFromWishlist().then(function () {
          window.location.reload();
        });
      })
      .catch(function () {
        moveButton.disabled = false;
        moveButton.textContent = "Move to cart";
        showError(itemEl, "Couldn't add this item, it may be unavailable");
      });
  });

  function init() {
    container = document.querySelector("[data-saved-for-later]");
    if (!container) return;
    itemsEl = container.querySelector("[data-saved-for-later-items]");
    var markers = loadMarkers();
    if (!markers.length) return;
    render(markers);
    verify();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


/* ------------------------------------------------------------------
   Add-to-cart press feedback + haptics
   - Adds .is-pressed to add-to-cart buttons on pointerdown (held for at
     least 150ms) so the pressed colour shows even on a quick tap, where
     :active can be too brief or (iOS) not applied at all.
   - Fires a short haptic tap on a real (trusted) click via
     navigator.vibrate (Android Chrome). Browsers without it, including
     every iPhone browser, simply skip it. No iPhone workaround on purpose:
     Apple closed the hidden-switch trick in iOS 26.5, and the remaining
     method would put an overlay on top of the add to cart button.
   Covers the product form button, quickshop (injected later), the sticky
   mobile bar, and collection-card add-to-cart buttons.
   ------------------------------------------------------------------ */
(function () {
  var SELECTOR = '[data-product-submit], [data-product-card-interaction-addtocart], [data-sticky-atc-button]';
  var MIN_PRESS_MS = 150;

  function target(e) {
    var el = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!el || el.disabled) return null;
    return el;
  }

  /* Pressed state */
  document.addEventListener('pointerdown', function (e) {
    if (!e.isTrusted) return;
    var el = target(e);
    if (!el) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    el.classList.add('is-pressed');
    el.dataset.pressedAt = String(Date.now());
  }, { passive: true });

  function release(e) {
    var el = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!el || !el.classList.contains('is-pressed')) return;
    var held = Date.now() - Number(el.dataset.pressedAt || 0);
    var wait = Math.max(0, MIN_PRESS_MS - held);
    setTimeout(function () { el.classList.remove('is-pressed'); }, wait);
  }
  document.addEventListener('pointerup', release, { passive: true });
  document.addEventListener('pointercancel', release, { passive: true });
  document.addEventListener('pointerleave', release, true);

  /* Haptics (Android only; no-op where navigator.vibrate is missing) */
  function hapticTap() {
    try {
      if (typeof navigator.vibrate === 'function') navigator.vibrate(15);
    } catch (err) { /* ignore */ }
  }

  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    if (window.tbAtcHaptics === false) return;
    var el = target(e);
    if (!el) return;
    if (el.classList.contains('addtocart-button-loading')) return;
    hapticTap();
  }, true);
})();


/* ------------------------------------------------------------------
   Mini cart quantity stepper (- qty +) in the cart drawer
   Markup: sections/static-cart-mini.liquid (.tb-qty).
   The theme script keeps its cart-drawer object private, so the stepper
   borrows the drawer's own Remove flow to reach the theme's refresh:
   1. A tap on - or + clicks the line's Remove button with an override
      set for that line.
   2. The theme's Remove handler posts /cart/change.js quantity=0 through
      jQuery. A jQuery ajaxPrefilter cancels every such request for that
      line before it is sent (the drawer registers its Remove handler
      again on each re-render, so one click can create several of them)
      and keeps the theme's success callback from the first one.
   3. The stepper shows the tapped quantity and its line price at once
      (the line is not dimmed; only the stepper goes grey while it waits)
      and sends one /cart/change.js with the wanted quantity. On success
      it calls the saved callback, which is exactly what the theme does
      after a remove: refresh its cached cart data, re-render the drawer
      (subtotal and free shipping bar catch up here) and update the
      header count. On the cart page the page is reloaded instead so the
      cart table underneath matches (the theme's own cart-page check looks
      for a section id this store's JSON templates never produce, so
      Remove leaves that table stale). /cart/change.js answers 422 when
      the wanted quantity is more than the stock on hand (it does not
      cap); then the quantity and price snap back, the plus button is
      disabled and a note says how many are available, which is the
      current quantity since the stepper moves one at a time.
   Safety: the override exists only during the synchronous click and is
   cleared straight after, so a real Remove is never touched. The Remove
   flow is borrowed only when the theme's jQuery is the page's jQuery,
   proven by the theme's own "theme:rimg:watch" handler being registered
   on document through it (true on every page). Otherwise, or when the
   click produced no request to cancel, the stepper still sends its own
   request and reloads the page on success.
   ------------------------------------------------------------------ */
(function () {
  var $ = window.jQuery;
  if (!$ || typeof $.ajaxPrefilter !== 'function' || !window.fetch) return;

  var pending = null; /* { id, cancelled, onSuccess } during a stepper tap */

  function themeUsesThisJquery() {
    try {
      var events = (typeof $._data === 'function' && $._data(document, 'events')) || {};
      return !!events['theme:rimg:watch'];
    } catch (err) {
      return false;
    }
  }

  $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    if (!pending) return;
    var url = String(options.url || '');
    if (!/\/cart\/change(\.js)?(\?|$)/.test(url)) return;
    var data = typeof options.data === 'string' ? options.data : '';
    var idRe = new RegExp('(^|&)id=' + pending.id + '(&|$)');
    if (!idRe.test(data) || !/(^|&)quantity=0(&|$)/.test(data)) return;
    if (!pending.onSuccess && typeof options.success === 'function') {
      pending.onSuccess = options.success;
    }
    pending.cancelled += 1;
    jqXHR.abort(); /* aborted inside a prefilter: jQuery never sends it */
  });

  function changeUrl() {
    var route = window.Theme && window.Theme.routes && window.Theme.routes.cart_change_url;
    return (route || '/cart/change') + '.js';
  }

  function lineFor(id) {
    return document.querySelector('[data-cart-mini-item="' + id + '"]');
  }

  function onCartPage() {
    return !!document.querySelector('form[data-cart-form]');
  }

  /* Same shape the theme prints for this store's money format ($1,234.56). */
  function money(cents) {
    var whole = Math.floor(cents / 100);
    var part = String(cents % 100);
    if (part.length < 2) part = '0' + part;
    return '$' + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + part;
  }

  function isPlainMoney(text) {
    return /^\$[\d,]+\.\d{2}$/.test(String(text || '').trim());
  }

  /* Show the tapped quantity and its line price right away. The drawer's
     own refresh replaces all of this about a second later. Returns an
     undo for the case where Shopify says no. */
  function preview(item, box, qty) {
    var valueEl = box.querySelector('[data-tb-qty-value]');
    var minus = box.querySelector('[data-tb-qty-step="minus"]');
    var finalEl = item.querySelector('.cart-mini-item-final-price');
    var originalEl = item.querySelector('.cart-mini-item-original-price');
    var unit = parseInt(box.getAttribute('data-tb-unit-price'), 10);
    var original = parseInt(box.getAttribute('data-tb-original-price'), 10);
    var before = {
      value: valueEl ? valueEl.textContent : '',
      minusDisabled: minus ? minus.disabled : false,
      finalText: finalEl ? finalEl.textContent : null,
      originalText: originalEl ? originalEl.textContent : null
    };
    if (valueEl) valueEl.textContent = String(qty);
    if (minus) minus.disabled = qty < 2;
    if (finalEl && unit > 0 && isPlainMoney(finalEl.textContent)) finalEl.textContent = money(unit * qty);
    if (originalEl && original > 0 && isPlainMoney(originalEl.textContent)) originalEl.textContent = money(original * qty);
    box.classList.add('tb-qty--busy');
    return function undo() {
      if (valueEl) valueEl.textContent = before.value;
      if (minus) minus.disabled = before.minusDisabled;
      if (finalEl && before.finalText !== null) finalEl.textContent = before.finalText;
      if (originalEl && before.originalText !== null) originalEl.textContent = before.originalText;
      box.classList.remove('tb-qty--busy');
    };
  }

  function settle(id, status, current, undo) {
    if (typeof undo === 'function') undo();
    var item = lineFor(id);
    if (!item) return;
    item.classList.remove('cart-mini-item-loading');
    var box = item.querySelector('[data-tb-qty]');
    if (!box) return;
    box.classList.remove('tb-qty--busy');
    var note = item.querySelector('.tb-qty__note');
    if (!note) {
      note = document.createElement('span');
      note.className = 'tb-qty__note';
      box.insertAdjacentElement('afterend', note);
    }
    if (status === 422) {
      var plus = box.querySelector('[data-tb-qty-step="plus"]');
      if (plus) plus.disabled = true;
      note.textContent = 'Only ' + current + ' available';
    } else {
      note.textContent = 'Could not update, please try again';
    }
  }

  function change(id, qty, current, onSuccess, undo) {
    fetch(changeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: qty })
    }).then(function (response) {
      if (response.ok) {
        if (typeof onSuccess === 'function' && !onCartPage()) {
          onSuccess();
        } else {
          window.location.reload();
        }
        return;
      }
      settle(id, response.status, current, undo);
    }).catch(function () {
      settle(id, 0, current, undo);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-tb-qty-step]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var box = btn.closest('[data-tb-qty]');
    var item = btn.closest('[data-cart-mini-item]');
    if (!box || !item) return;
    if (box.classList.contains('tb-qty--busy') || item.classList.contains('cart-mini-item-loading')) return;
    var valueEl = box.querySelector('[data-tb-qty-value]');
    var current = parseInt(valueEl && valueEl.textContent, 10);
    if (!(current > 0)) return;
    var next = btn.getAttribute('data-tb-qty-step') === 'plus' ? current + 1 : current - 1;
    if (next < 1) return;
    var id = item.getAttribute('data-cart-mini-item');
    var removeBtn = item.querySelector('[data-cart-mini-item-remove]');
    var note = item.querySelector('.tb-qty__note');
    if (note) note.remove();

    var onSuccess = null;
    if (removeBtn && themeUsesThisJquery()) {
      pending = { id: id, cancelled: 0, onSuccess: null };
      removeBtn.click(); /* the theme tries to post; every post is cancelled above */
      if (pending.cancelled > 0) onSuccess = pending.onSuccess;
      pending = null;
    }
    /* The theme dims the whole line for a remove; a quantity change keeps the line as it is. */
    item.classList.remove('cart-mini-item-loading');
    var undo = preview(item, box, next);
    change(id, next, current, onSuccess, undo);
  });
})();


/* ------------------------------------------------------------------
   Cart drawer: keep the scroll position across a re-render
   After a quantity change or a Remove the theme rebuilds the drawer's
   content (innerHTML of [data-sidebar-drawer-content]), and the list
   inside it ([data-cart-mini-content], the part that scrolls) comes back
   as a new element scrolled to the top, which sent a shopper who had
   scrolled down back to the top. This remembers how far the list was
   scrolled (scroll events don't bubble, but the wrapper can capture
   them) and puts the new list at the same spot right after a rebuild
   that happens while the drawer is already open, in the same frame and
   again next frame in case the theme's focus handling moves it. A fresh
   open still starts at the top: that rebuild happens while the drawer's
   state is still "closed".
   ------------------------------------------------------------------ */
(function () {
  if (!window.MutationObserver) return;
  var LIST = '[data-cart-mini-content]';

  function setup() {
    var content = document.querySelector('[data-sidebar-drawer-content]');
    var container = document.querySelector('.sidebar-drawer-container');
    if (!content || !container) return;
    var lastTop = 0;

    content.addEventListener('scroll', function (e) {
      var el = e.target;
      if (el && el.matches && el.matches(LIST)) lastTop = el.scrollTop;
    }, true);

    function restore(top) {
      var list = content.querySelector(LIST);
      if (list && Math.abs(list.scrollTop - top) > 1) list.scrollTop = top;
      return list;
    }

    new MutationObserver(function (records) {
      var rebuilt = records.some(function (record) {
        return record.type === 'childList' && record.removedNodes.length > 0;
      });
      if (!rebuilt) return;
      if (container.getAttribute('data-sidebar-drawer-animation-state') !== 'open') {
        lastTop = 0;
        return;
      }
      var top = lastTop;
      if (!(top > 0)) return;
      restore(top);
      window.requestAnimationFrame(function () {
        var list = restore(top);
        if (list) lastTop = list.scrollTop;
      });
    }).observe(content, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();


/* ------------------------------------------------------------------
   Recents icon (history clock) next to the wishlist heart
   The Swish wishlist app injects its heart when its script loads:
   <wishlist-link class="wk-desktop"> into the header tools and
   <wishlist-link class="wk-mobile"> into the phone menu panel
   (.mobile-dropdown--tools). The Recents link is added the same way: as
   soon as a heart appears, a link to the Recently Viewed page is placed
   just to its left, drawn as a black outline clock with a back arrow (the
   usual "history" symbol) in the heart's style: 1.5px strokes, 18px in the
   header, 30px with a "Recents" label in the phone menu, 0 8px padding,
   13px bold label whose bottom lines up with the heart's "Wishlist". The
   header icon hides at 480px and below, where the app hides its header
   heart. If the app ever goes, the icon goes with it.
   ------------------------------------------------------------------ */
(function () {
  var PAGE = '/pages/recently-viewed-products';
  var LABEL = 'Recents';
  var STROKE = 'fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"';
  var SVG =
    '<svg viewBox="0 0 64 64" width="{s}" height="{s}" aria-hidden="true" focusable="false">' +
    '<path d="M10.5 19A26 26 0 1 1 10.5 45" ' + STROKE + '/>' +
    '<path d="M19.2 16.7L10.5 19 8.2 10.3" ' + STROKE + '/>' +
    '<path d="M33 18V32L42 39" ' + STROKE + '/>' +
    '</svg>';
  var CSS =
    '.tb-recents{display:inline-flex;align-items:center;justify-content:center;color:#000;text-decoration:none;line-height:1}' +
    '.tb-recents:hover,.tb-recents:focus{color:#000;text-decoration:none}' +
    '.tb-recents svg{display:block}' +
    '.tb-recents--desktop{padding:0 8px;position:relative;top:-1px}' +
    '@media screen and (max-width:480px){.tb-recents--desktop{display:none}}' +
    '.tb-recents--mobile{margin-left:auto;flex-direction:column;gap:7px;padding:0 8px;position:relative;top:0;font-weight:700;font-size:13px}' +
    '.tb-recents--mobile svg{position:relative;top:8px;margin-bottom:2px}' +
    '.tb-recents__text{white-space:nowrap;line-height:1.4}';

  function addStyle() {
    if (document.getElementById('tb-recents-style')) return;
    var style = document.createElement('style');
    style.id = 'tb-recents-style';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function make(kind) {
    var a = document.createElement('a');
    a.className = 'tb-recents tb-recents--' + kind;
    a.href = PAGE;
    if (kind === 'desktop') a.setAttribute('aria-label', 'Recently viewed products');
    a.innerHTML = SVG.replace(/\{s\}/g, kind === 'mobile' ? '30' : '18') +
      (kind === 'mobile' ? '<span class="tb-recents__text">' + LABEL + '</span>' : '');
    return a;
  }

  function place() {
    var hearts = document.querySelectorAll('wishlist-link.wk-desktop, wishlist-link.wk-mobile');
    var done = 0;
    for (var i = 0; i < hearts.length; i++) {
      var heart = hearts[i];
      var prev = heart.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('tb-recents')) { done += 1; continue; }
      if (!heart.parentNode) continue;
      addStyle();
      heart.parentNode.insertBefore(make(heart.classList.contains('wk-mobile') ? 'mobile' : 'desktop'), heart);
      done += 1;
    }
    return done;
  }

  function start() {
    if (place() >= 2 || !window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      if (place() >= 2) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
